/* Built In Imports */

import { Box } from "@chakra-ui/react";
import TopBannerEventHyttV2 from "@components/HeaderBanner/TopBannerEventHyttV2";
import { RenderFAQs } from "@components/UI/Common/SectionCommonUI";
import StyleConfig from "@components/UI/Common/StyleConfig";
import HowtoApplyV2 from "@landing_pages/hytt/sections/HowtoApplyV2";
import HyttTestimonial from "../components/Testimonial/HyttTestimonial";
import FacilitiesAndInclusionV2 from "../sections/FacilitiesAndInclusionV2";
import OfferingV1 from "../sections/OfferingV1";
import Quotes from "../sections/Quotes";
import OtherAspects from "../sections/OtherAspects";
import PostProgram from "../sections/PostProgram";
import PracticeCurriculumV1 from "../sections/PracticeCurriculumV1";
import ProgramFeeV1 from "../sections/ProgramFeeV1";
import ProgramHighlightsV2 from "../sections/ProgramHighlightsV2";
import SneakPeakV2 from "../sections/SneakPeakV2";
import FreeWebinar from "@landing_pages/hytt/components/Stickybar/FreeWebinar";
import ApplyStickyButton from "@landing_pages/hytt/components/ApplyStickyButton";
import config from '@config';

/* External Imports */
// import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */

/**
 * Renders Render Sadhguru In Aus Sections
 *
 * @param {object} sectionContent - Data
 * @param {string} region - Region of Page
 * @param {string} lang - Language of Page
 * @returns {ReactElement} Render Sadhguru In Aus Sections
 */

const RenderSectionsV1 = ({
    section,
    pageName,
    region,
    lang,
    pType,
    csrData,
    pageData,
    mode,
    formElement,
}) => {
    // console.log("The section is", section)
    const sectionId = section?.sectionId;
    if (sectionId === 'top-banner') {
        return (
            <StyleConfig
                id={section.sectionId}
                key={section.sectionId}
                pT="0"
                pB="0"
                marginTop="0"
                mB="0"
                section={section}
                zIndex={"-10"}
                background = {'inear-gradient(90.07deg, #1D1D1D 1.11%, #1D1D1D 14.61%, rgba(29, 29, 29, 0) 77.71%)'}

            >
                <TopBannerEventHyttV2
                    pageData={pageData}
                    secImage={section?.sectionContent[1]}
                    sectionContent={section?.sectionContent[0]}
                    pageConfig={pageData?.pageConfig}
                />
            </StyleConfig >
        );
    }
    else if (sectionId === 'apply-sticky-button') {
        return (
          <ApplyStickyButton
            lang={lang}
            region={region}
            sectionContent={section.sectionContent}
            pageData={pageData}
            pageName={pageName}
          />
        );
      }
    else if(sectionId === 'hytt-free-webinar'){
        return (   
                <div style={{ position: 'relative' }}>
                    <FreeWebinar 
                    sectionContent={section?.sectionContent}
                    />
                </div> );
    }
    else if (sectionId === 'offerings') {
        return (
            <div style={{ position: 'relative' , height: '100%'}}>
                <StyleConfig
                    id={section.sectionId}
                    key={section.sectionId}
                    pT="0"
                    pB="0"
                    mB="0"
                    style={section?.styleConfig}
                    section={section}
                    //height={{base:'550px', lg:'775px', md:"775px", sm:'550px'}}
                >
                    <OfferingV1 sectionContent={section?.sectionContent} />
                </StyleConfig >
            </div >
        );
    }
    else if (sectionId === 'quotes') {
        return (
            <div style={{ position: 'relative', background: 'linear-gradient(#F6EDDE -17.92%, #F6EDDE 5.19%, rgba(246, 237, 222, 0) 95.19%)' }}>
                <StyleConfig
                    id={section.sectionId}
                    key={section.sectionId}
                    pT="0"
                    pB="0"
                    mB="0"
                    style={section?.styleConfig}
                    section={section}
                >
                    <Quotes sectionContent={section?.sectionContent} />
                </StyleConfig >
            </div >
        );
    }
    if (sectionId === 'hytt-program-highlights') {
        return (
            <StyleConfig
                id={section.sectionId}
                key={section.sectionId}
                pT="0"
                pB="0"
                marginTop="0"
                mB="0"
                section={section}
                zIndex={"-10"}
            >
                <ProgramHighlightsV2 pageData={pageData} pageConfig={pageData?.pageConfig} sectionContent={section?.sectionContent} />
            </StyleConfig>
        );
    }
    else if (sectionId === 'sneak-peak') {
        return (
            <div style={{ position: 'relative' }}>
                <Box
                    background="#FFAE27"
                    zIndex="-2"
                    clipPath={{ sm: " polygon(0 0, 100% 15%, 100% 100%, 0% 100%)", base: " polygon(0 0, 100% 15%, 100% 100%, 0% 100%)", md: "polygon(0 0, 100% 40%, 100% 100%, 0% 100%)" }}
                    position="absolute"
                    top="0"
                    left="0"
                    right="0"
                    bottom="0"
                />
                <StyleConfig
                    id={section.sectionId}
                    key={section.sectionId}
                    // pT="0"
                    pB="0"
                    marginTop="0"
                    mB="0"
                    style={section?.styleConfig}
                    section={section}
                    zIndex={10}
                    clipPath={{ base: "polygon(0 13%, 100% 0, 100% 100%, 0% 100%)", md: "polygon(0 13%, 100% 0, 100% 100%, 0% 100%)" }}
                >
                    <SneakPeakV2 sectionContent={section?.sectionContent} />
                </StyleConfig>
            </div>
        );
    }
    else if (sectionId === 'practice-curriculum') {
        return (
            <StyleConfig
                id={section.sectionId}
                key={section.sectionId}
                //pT="20px"
                //pB="0"
                //marginTop="50px"
                mB="0"
                style={section?.styleConfig}
                paddingTop={{ sm: "50px", base: "50px", md: "60px" }}
                paddingBottom={{ sm: "0px", base: "0px", md: "60px", lg:"60px" }}
                //height={{ sm: "", base: "600px", md: "600px" }}
                section={section}
            >
                <PracticeCurriculumV1 pageData={pageData} sectionContent={section?.sectionContent} />
            </StyleConfig>
        );
    }

    else if (sectionId === 'post-program-support') {
        return (
            <StyleConfig
                id={section.sectionId}
                key={section.sectionId}
                pT="0"
                marginTop="0"
                pB="0"
                mB="0"
                section={section}
            >
                <PostProgram sectionContent={section?.sectionContent} />
            </StyleConfig>
        );
    }
    else if (sectionId === 'facilities-and-inclusions') {
        return (
            <StyleConfig
                id={section.sectionId}
                key={section.sectionId}
                pT="0"
                marginTop="0"
                pB="0"
                mB="0"
                section={section}
            >
                <FacilitiesAndInclusionV2 sectionContent={section?.sectionContent} />
            </StyleConfig>
        );
    }

    else if (sectionId === 'other-aspects-of-training') {
        return (
            <div style={{ position: 'relative' }}>
                <StyleConfig
                    id={section.sectionId}
                    key={section.sectionId}
                    pT="0"
                    pB="0"
                    marginTop="0"
                    mB="0"
                    style={section?.styleConfig}
                    section={section}
                >
                    <Box
                        maxHeight={"753px"}
                        background="#FFAE27" 
                        zIndex="-2"
                        clipPath={{ base: "polygon(0 10%, 100% 0, 100% 100%, 0% 100%)", sm: "polygon(0 10%, 100% 0, 100% 100%, 0% 100%)", md: "polygon(0 45%, 100% 0, 100% 100%, 0% 100%)" }}
                        // clipPath={"polygon(0 54%, 100% 0, 100% 100%, 0% 100%);"}
                        position="absolute"
                        top="0"
                        left="0"
                        right="0"
                        bottom="0"
                    />
                    <Box
                        // maxHeight={{ base: "778", sm: "778px", md: "753px" }}
                        zIndex={10}
                        background="#C95B1D"
                        clipPath={{ base: " polygon(0 0, 100% 5%, 100% 100%, 0% 100%)", sm: " polygon(0 0, 100% 5%, 100% 100%, 0% 100%))", md: "polygon(0 0, 100% 15%, 100% 100%, 0% 100%)" }}
                        paddingBottom={{ base: "50px", sm: "50px", md: "0px" }}
                    >
                        <OtherAspects sectionContent={section?.sectionContent} />
                    </Box>
                </StyleConfig>
            </div >
        );
    }
    else if (sectionId === 'testimonial-ys') {
        return (
            <StyleConfig
                id={section.sectionId}
                key={section.sectionId}
                pT="0"
                marginTop="0"
                pB="0"
                mB="0"
                section={section}
                style={section?.styleConfig}
            >
                <Box
                    display="flex">
                    <HyttTestimonial
                        pageData={pageData}
                        sectionContent={section?.sectionContent}
                    />
                </Box>
            </StyleConfig>
        );
    }
    else if (sectionId === 'program-fee') {
        return (
            <StyleConfig
                id={section.sectionId}
                key={section.sectionId}
                pT="0"
                pB="0"
                marginTop="0"
                mB="0"
                section={section}
                style={section?.styleConfig}
            >
                <ProgramFeeV1 pageData={pageData} sectionContent={section?.sectionContent} />
            </StyleConfig>
        );
    }
    else if (sectionId === 'how-to-apply') {
        return (
            <StyleConfig
                id={section.sectionId}
                key={section.sectionId}
                pT="30px"
                pB={{base:"",sm:"", md:"30px", lg:"30px"}}
                marginTop="0"
                mB="0"
                style={section.styleConfig}
                backgroundPosition="-1000px"
                backgroundRepeat="no-repeat"
            >
                <HowtoApplyV2 section={section} sectionContent={section?.sectionContent} region={region} lang={lang} />
            </StyleConfig>
        );
    }
    // else if (sectionId === 'talk-to-our-alumni') {
    //     return (
    //         <StyleConfig
    //             id={section.sectionId}
    //             key={section.sectionId}
    //             pT="30px"
    //             pB="30px"
    //             marginTop="0"
    //             mB="0"
    //             style={section.styleConfig}
    //         >
    //             <TalktoAlumni sectionContent={section?.sectionContent} region={region} lang={lang} formElement={formElement} />
    //         </StyleConfig>
    //     );
    // }
    else if(sectionId === 'hytt-free-webinar'){
        return (   
                <div style={{ position: 'relative' }}>
                    <FreeWebinar 
                    sectionContent={section?.sectionContent}
                    />
                </div> );
    }
    else if (sectionId === 'faq-section') {
        return (
            <StyleConfig
                id={section.sectionId}
                key={section.sectionId}
                pT="0"
                pB="0"
                marginTop="0"
                mB="0"
                section={section}
            >
            <Box margin={{ base: '', sm: "", md: "40px 0px" }}
                bgImage={{base:'', md:`url(${config.imgPath}/d/46272/1733835026-right_faq.png)`}}
                bgRepeat={'no-repeat'}
                bgPosition={'right 0px'}
            >
                    <RenderFAQs pageConfig={pageData?.pageConfig} section={section} />
                </Box>

            </StyleConfig>
        );
    }


};

export default RenderSectionsV1;
